// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1kkE9","sendOtp":"AuthorizeToLogin_sendOtp___69kZ"};